<template>
  <Content class="goodsBox">
    <Form id="searchForm" :model="formItem" :label-width="80" inline>
      <FormItem label="区域名称">
        <Input v-model="formItem.key" placeholder="模糊搜索" clearable />
      </FormItem>
      <FormItem :label-width="20">
        <Button type="primary" @click="search">查询</Button>
        <Button style="margin-left: 8px" @click="clear">重置</Button>
      </FormItem>
    </Form>
    <Table
      :columns="columns"
      :data="tableData"
      :height="tablesHeight"
      border
    ></Table>
    <Page
      class="table_page_css"
      v-show="total"
      :total="total"
      :current="searchInfo.pageNo"
      :page-size="searchInfo.pageSize"
      :page-size-opts="pageSizeOpts"
      @on-change="pageNoChange"
      @on-page-size-change="pageSizeChange"
      show-sizer
      show-elevator
      show-total
    />
  </Content>
</template>
<script>
import { rescueList,deleterescue } from '@/api/rescue'
export default {
  name: '',
  data() {
    return {
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center',
        },
        {
          title: '标题',
          key: 'name',
        },
        {
          title: '小车名',
          key: 'car.car_ref',
          render: (h, params) => {
            return h(
              'div',
              params.row.car ? params.row.car.car_name : '',
            )
          },
        },
        {
          title: '小车标识',
          key: 'car.car_ref',
          render: (h, params) => {
            return h(
              'div',
              params.row.car ? params.row.car.car_ref : '',
            )
          },
        },
        {
          title: '备注',
          key: 'name',
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Poptip',
                {
                  props: {
                    confirm: true,
                    transfer: true,
                    title: '您确认处理这条内容吗？',
                  },
                  on: {
                    'on-ok': () => {
                      this.remove(params.row._id)
                    },
                  },
                },
                [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small',
                      },
                      style: {
                        marginRight: '5px',
                      },
                    },
                    '处理',
                  ),
                ],
              ),
            ])
          },
        },
      ],
      tableData: [],
      total: 0,
      searchInfo: {
        pageNo: 1,
        pageSize: 5,
      },
      pageSizeOpts: [1, 2, 5, 10],
      formItem: {
        key: '',
      },
      tablesHeight: 0,
    }
  },
  methods: {
    // 设置表格高度，使其适应视口大小
    setTablesHeight() {
      let aH = 0 // 初始化表格高度变量
      let oA = document.getElementById('app') // 获取包含整个应用的DOM元素
      let oH = oA.clientHeight || oA.offsetHeight // 获取应用的高度
      let sA = document.getElementById('searchForm') // 获取搜索表单的DOM元素
      let sH = sA.clientHeight || sA.offsetHeight // 获取搜索表单的高度
      aH = oH - sH - 265 // 计算表格的高度（应用高度 - 搜索表单高度 - 预留的固定高度）
      this.tablesHeight = aH // 将计算得到的表格高度赋值给组件的数据属性
    },

    // 获取客户列表数据的函数
    getList() {
      rescueList(this.searchInfo) // 调用获取客户列表的API
        .then((res) => {
          // 处理成功的响应
          if (res.data.code === 200) {
            // 如果响应码为200，表示请求成功
            const data = res.data // 获取响应数据
            this.tableData = data.data // 将客户列表数据赋值给组件的数据属性
            this.total = data.total // 将总记录数赋值给组件的数据属性
          } else {
            this.$Message.error(res.data.msg) // 如果响应码不是200，显示错误消息
          }
        })
        .catch((err) => {
          // 处理错误的响应
          this.$Message.error(err) // 显示错误消息
        })
    },

    // 执行搜索操作的函数
    search() {
      this.searchInfo = {
        // 更新搜索信息
        key: this.formItem.key, // 搜索关键字
        pageNo: 1, // 重置页码为1
        pageSize: this.searchInfo.pageSize, // 保持当前页大小不变
      }
      this.getList() // 调用获取列表数据的函数
    },

    // 清除搜索条件并重新获取列表数据的函数
    clear() {
      this.formItem = {
        // 重置表单数据
        key: '', // 清空搜索关键字
      }
      this.searchInfo = {
        // 重置搜索信息
        pageNo: 1, // 重置页码为1
        pageSize: 5, // 重置页大小为5
      }
      this.getList() // 调用获取列表数据的函数
    },

    // 删除区域的函数
    remove(_id) {
      deleterescue({ _id: _id }) // 调用删除区域的API
        .then((res) => {
          // 处理成功的响应
          if (res.data.code === 200) {
            // 如果响应码为200，表示删除成功
            this.$Message.success('处理成功') // 显示成功消息
            this.getList() // 重新获取列表数据
          } else {
            this.$Message.error(res.data.msg) // 如果响应码不是200，显示错误消息
          }
        })
        .catch((err) => {
          // 处理错误的响应
          this.$Message.error(err) // 显示错误消息
        })
    },

    // 当页码发生变化时的处理函数
    pageNoChange(current) {
      this.searchInfo.pageNo = current // 更新当前页码
      this.getList() // 重新获取列表数据
    },

    // 当页大小发生变化时的处理函数
    pageSizeChange(val) {
      this.searchInfo.pageNo = 1 // 重置页码为1
      this.searchInfo.pageSize = val // 更新页大小
      this.getList() // 重新获取列表数据
    },
  },
  mounted() {
    this.getList()
    setTimeout(() => {
      this.setTablesHeight()
    }, 50)
    window.onresize = () => {
      this.setTablesHeight()
    }
  },
}
</script>
<style lang="less" scoped>
.goodsBox {
  .ivu-form-inline .ivu-form-item {
    width: 267px;
  }
}
</style>
